import { tokenHandler } from "@shared/utils";
import { produce } from "immer";
import { ActionType, createReducer } from "typesafe-actions";

import { AuthStateType } from "../interfaces";
import * as actions from "./actions";

type Action = ActionType<typeof actions>;

const initialState: AuthStateType = {
  authentificated: !!tokenHandler.get(),
  hasOneTimePassword: !!tokenHandler.getSPToken(),
};

const reducer = createReducer<AuthStateType, Action>(initialState)
  .handleAction(actions.verify.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.authentificated = !!action.payload.token;
    }),
  )
  .handleAction(actions.login.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.hasOneTimePassword = !!action.payload.set_password_token;
    }),
  )
  .handleAction(actions.logout.success, (state) =>
    produce(state, (nextState) => {
      nextState.authentificated = false;
      nextState.hasOneTimePassword = false;
    }),
  )
  .handleAction(actions.setPassword.success, (state) =>
    produce(state, (nextState) => {
      nextState.hasOneTimePassword = false;
    }),
  );

export { reducer as AuthReducer };
